export default __webpack_public_path__ + "static/media/CHEMCAD NXT_Logo_RGB_300_square.1de7ad77.png";